import { TextAreaProps } from "antd/es/input";

export const textProps = {
  rows: 6,
  size: "small",
  style: { height: "100%" },
} satisfies TextAreaProps;
